"use client";

import * as React from "react";
import {
  Compass,
  Stethoscope,
  Activity,
  Target,
  ShieldCheck,
  Briefcase,
  Lightbulb,
  Building2,
  Globe2,
  Mic,
  Scale,
  Lock,
  Cpu,
  Eye,
  Zap,
  HeartPulse,
  Award,
  Crown,
  BookOpen,
  Heart,
} from "lucide-react";

export function NamedIcon({ name, className }: { name: string; className?: string }): React.ReactElement {
  switch (name) {
    case "Compass": return <Compass className={className} />;
    case "Stethoscope": return <Stethoscope className={className} />;
    case "Activity": return <Activity className={className} />;
    case "Target": return <Target className={className} />;
    case "ShieldCheck": return <ShieldCheck className={className} />;
    case "Briefcase": return <Briefcase className={className} />;
    case "Lightbulb": return <Lightbulb className={className} />;
    case "Building2": return <Building2 className={className} />;
    case "Globe2": return <Globe2 className={className} />;
    case "Mic": return <Mic className={className} />;
    case "Scale": return <Scale className={className} />;
    case "Lock": return <Lock className={className} />;
    case "Cpu": return <Cpu className={className} />;
    case "Eye": return <Eye className={className} />;
    case "Zap": return <Zap className={className} />;
    case "HeartPulse": return <HeartPulse className={className} />;
    case "Award": return <Award className={className} />;
    case "Crown": return <Crown className={className} />;
    case "BookOpen": return <BookOpen className={className} />;
    case "Heart": return <Heart className={className} />;
    default: return <BookOpen className={className} />;
  }
}
